import { render, staticRenderFns } from "./ErrorBlock.vue?vue&type=template&id=22984306&scoped=true&"
import script from "./ErrorBlock.vue?vue&type=script&lang=js&"
export * from "./ErrorBlock.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBlock.vue?vue&type=style&index=0&id=22984306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22984306",
  null
  
)

export default component.exports